import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Create an Axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to include the token dynamically
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Retrieve token from localStorage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🔹 Rutas
export const getRuta = async () => apiClient.get(`/ruta`);

// 🔹 Recibo
export const crearRecibo = async (reciboData) => apiClient.post(`/recibo`, reciboData);

// 🔹 Usuarios
export const getUsers = async () => apiClient.get(`/usuario`);
export const getUsuarioByUser_Id = async (id) => apiClient.get(`/usuario/${id}`);
export const updateUser = async (id, userData) => apiClient.put(`/usuario/${id}`, userData);
export const bloquearUsuarioBy_Id = async (id) => apiClient.put(`/usuario/bloquear/${id}`);
export const desbloquearUsuarioBy_Id = async (id) => apiClient.put(`/usuario/desbloquear/${id}`);

// 🔹 Ejercicio
export const createEjercicio = async (userData) => apiClient.post(`/ejercicio`, userData);
export const getEjercicioByUser_Id = async (id) => apiClient.get(`/ejercicio/${id}`);
export const putEjercicioByEjercicio_Id = async (id, updatedData) => apiClient.put(`/ejercicio/${id}`, updatedData);
export const deleteEjercicioBy_Id = async (id) => apiClient.delete(`/ejercicio/${id}`);

// 🔹 Peso
export const createPeso = async (userData) => apiClient.post(`/peso`, userData);
export const getPesoByUser_Id = async (id) => apiClient.get(`/peso/${id}`);
export const deletePesoBy_Id = async (id) => apiClient.delete(`/peso/${id}`);

// 🔹 Pagos
export const getPagos = async () => apiClient.get(`/pago`);
export const createPago = async (userData) => apiClient.post(`/pago`, userData);
export const getPagosByUser_Id = async (id) => apiClient.get(`/pago/${id}`);
export const updatePagoBy_Id = async (id, userData) => apiClient.put(`/pago/${id}`, userData);
export const deletePagoBy_Id = async (id, pagoData = null) => {
  const attempts = [
    () => apiClient.delete(`/pago/${id}`),
    () => apiClient.delete(`/pago`, { data: { id_pago: id, ...(pagoData || {}) } }),
    () => apiClient.post(`/pago/delete/${id}`),
    () => apiClient.post(`/pago/delete`, { id_pago: id, ...(pagoData || {}) }),
  ];

  let lastError;

  for (const attempt of attempts) {
    try {
      return await attempt();
    } catch (error) {
      const status = error?.response?.status;
      // Si backend responde con error de negocio (500, 409, etc.), no seguir intentando otras rutas.
      if (status && status !== 404 && status !== 405) {
        throw error;
      }
      lastError = error;
    }
  }

  throw lastError;
};

// 🔹 Asistencia
export const createAsistencia = async (userData) => apiClient.post(`/asistencia`, userData);
export const getAsistenciaByUser_Id = async (id) => apiClient.get(`/asistencia/${id}`);
export const updateAsistencia = async (id, userData) => apiClient.put(`/asistencia/${id}`, userData);

// 🔹 Autenticación
export const loginUser = async ({ usuario, contrasena, tipo_usuario }) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/login`, {
      usuario,
      contrasena,
      tipo_usuario,
    });

    if (response.status !== 200) {
      throw new Error("Invalid credentials or user not found.");
    }

    return response.data; // Should return { user, token }
  } catch (error) {
    throw error;
  }
};

export const createUser = async (formData) => {
  const response = await apiClient.post(`/usuario`, formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensures correct handling of formData
    },
  });

  if (!response.status === 200) {
    throw new Error("Error al crear usuario");
  }

  return response.data;
};

export const enviarToken = (data) => {
  return apiClient.post('/recuperar_contrasena', data);
};